import { useCallback, useEffect, useState } from "react";
import { SCREEN_SM, SCREEN_MD, SCREEN_LG, SCREEN_XL, SCREEN_XXL } from "shared/consts/styleValues";

export const useResize = () => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const handleResize = useCallback(() => {
    setWidth(document.body.offsetWidth);
    setHeight(document.body.offsetHeight);
  }, []);

  useEffect(() => {
    handleResize()
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  return { 
    width, 
    height,
    isScreenSm: matchMedia(`(width >= ${SCREEN_SM}px)`).matches,
    isScreenMd: matchMedia(`(width >= ${SCREEN_MD}px)`).matches,
    isScreenLg: matchMedia(`(width >= ${SCREEN_LG}px)`).matches,
    isScreenXl: matchMedia(`(width >= ${SCREEN_XL}px)`).matches,
    isScreenXxl: matchMedia(`(width >= ${SCREEN_XXL}px)`).matches,
  };
};
